<template>
	<div @click.self="$emit('cancel')" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-2xl p-6 w-11/12 md:w-2/3 lg:w-1/2 xl:w-2/5 animate-scale-in shadow-2xl">
			<div class="relative mb-5">
				<h2 class="text-2xl font-archivosemibold text-[var(--text-color)] text-center">
					Add Token Contract
				</h2>
				<button @click="$emit('cancel')" class="absolute top-0 right-0 p-1">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close" class="w-4 h-4"/>
				</button>
			</div>

			<div class="flex justify-center gap-4 mb-6">
				<button @click="$emit('update:tokenPopupMode', 'auto')" :class="['px-8 py-2 rounded-full font-archivomedium text-[var(--contract-popup-text-color)] text-sm transition-all duration-100', tokenPopupMode === 'auto' ? 'bg-[var(--accent-color)] text-[var(--contract-popup-text-color)] shadow-md scale-105' : 'bg-[var(--accent-color)]/30 text-[var(--contract-popup-text-color)]']">
					Auto
				</button>
				<button @click="$emit('update:tokenPopupMode', 'custom')" :class="[ 'px-6 py-2 rounded-full font-archivomedium text-[var(--contract-popup-text-color)] text-sm transition-all duration-100', tokenPopupMode === 'custom' ? 'bg-[var(--accent-color)] text-[var(--contract-popup-text-color)] shadow-md scale-105' : 'bg-[var(--accent-color)]/30 text-[var(--contract-popup-text-color)]']">
					Custom
				</button>
			</div>

			<div class="relative h-72">
				<transition name="popup-swap" mode="out-in">
					<!-- “Auto” mode -->
					<div v-if="tokenPopupMode === 'auto'" key="auto" class="absolute inset-0 flex flex-col justify-between">
						<div>
							<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]"> 
								Contract Address
							</label>
							<input :value="tokenAddress" @input="$emit('update:tokenAddress', $event.target.value)" type="text" placeholder="0x…" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--text-color)] font-archivolight focus:outline-none shadow-inner"/>
						</div>
						<div class="flex flex-col w-full space-y-1 items-center justify-center">
							<button v-if="selectedChain.name === 'Ethereum'" @click="$emit('import-preferences')" :disabled="defaultTokensImported" class="px-6 py-2 mb-2 rounded-full text-[var(--secondary-text-color)] underline underline-[var(--accent-color)] disabled:opacity-60 disabled:cursor-not-allowed hover:scale-105 transition duration-100"> 
								{{ defaultTokensImported ? 'Suggested Tokens Already Imported' : 'Cardware Token Suggestions' }}
							</button>
							<button @click="$emit('validate')" :disabled="isValidating" :class="['w-full py-2 font-archivoregular rounded-full border-2 transition flex justify-center items-center', isValidating ? 'bg-[var(--accent-color)]/50 border-[var(--accent-color)]/50 cursor-not-allowed' : 'bg-[var(--accent-color)] text-[var(--hover-text-color)] border-[var(--accent-color)] hover:bg-transparent hover:text-[var(--accent-color)]']">
								<div v-if="isValidating" class="loader w-5 h-5"></div>
								<span v-else>Validate</span>
							</button>
						</div>
					</div>

					<!-- “Custom” mode -->
					<div v-else key="custom" class="absolute inset-0 flex flex-col justify-between">
						<div class="space-y-3">
							<div>
								<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]" >
									Contract Address
								</label>
								<input :value="tokenAddress" @input="$emit('update:tokenAddress', $event.target.value)" placeholder="0x…" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--text-color)] font-archivolight focus:outline-none shadow-inner"/>
							</div>
							<div>
								<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]">
									Decimals
								</label>
								<input :value="tokenDecimals" @input="$emit('update:tokenDecimals', $event.target.value)" placeholder="18" type="number" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--text-color)] font-archivolight focus:outline-none shadow-inner"/>
							</div>
							<div class="flex gap-2">
								<div class="flex-1">
									<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]">
										Ticker
									</label>
									<input :value="tokenTicker" @input="$emit('update:tokenTicker', $event.target.value)" placeholder="USDC" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--text-color)] font-archivolight focus:outline-none shadow-inner"/>
									</div>
									<div class="flex-1">
									<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]">
										Name
									</label>
									<input :value="tokenName" @input="$emit('update:tokenName', $event.target.value)" placeholder="USD Coin" class="w-full px-4 py-2 rounded-lg bg-[var(--dropdown-bg-color)] text-[var(--text-color)] font-archivolight focus:outline-none shadow-inner"/>
								</div>
							</div>
						</div>
						<button @click="$emit('validate')" :disabled="isValidating" :class="['w-full py-2 font-archivoregular rounded-full border-2 transition flex justify-center items-center', isValidating ? 'bg-[var(--accent-color)]/50 border-[var(--accent-color)]/50 cursor-not-allowed' : 'bg-[var(--accent-color)] text-[var(--hover-text-color)] border-[var(--accent-color)] hover:bg-transparent hover:text-[var(--accent-color)]']">
							<div v-if="isValidating" class="loader w-5 h-5"></div>
							<span v-else>Validate</span>
						</button>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		selectedChain: { type: Object, required: true },
		tokenPopupMode: { type: String, required: true },
		tokenAddress: { type: String, required: true },
		tokenDecimals: { type: String, required: true },
		tokenTicker: { type: String, required: true },
		tokenName: { type: String, required: true },
		isValidating: { type: Boolean, required: true },
		defaultTokensImported: { type: Boolean, required: true }
	});

	const emit = defineEmits([
		'cancel',
		'import-preferences',
		'validate',
		'update:tokenPopupMode',
		'update:tokenAddress',
		'update:tokenDecimals',
		'update:tokenTicker',
		'update:tokenName'
	]);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}

	.loader {
		border: 8px solid #f3f3f3;
		border-top: 8px solid var(--accent-color);
		border-radius: 50%;
		width: 28px;
		height: 28px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
	to {
		transform: rotate(360deg);
	}
	}
</style>
